
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ThumbsUp } from "lucide-react";

const FeedbackCard: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto">
      <Card className="border-sauna-blue/20">
        <CardContent className="p-6">
          <div className="text-center mb-8">
            <h3 className="text-xl font-semibold mb-2 text-sauna-navy">We Value Your Input</h3>
            <p className="text-gray-600">
              SaunaDip is built for wellness entrepreneurs like you. Help us create the platform you need.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-sauna-beige/50 p-5 rounded-lg">
              <h4 className="font-medium mb-3 flex items-center gap-2">
                <ThumbsUp size={18} className="text-sauna-orange" />
                <span>One-Click Feedback</span>
              </h4>
              <p className="text-sm text-gray-600 mb-4">
                Simple thumbs up/down feedback throughout the platform helps us quickly improve features.
              </p>
              <div className="flex items-center justify-center gap-4 mt-6">
                <Button variant="outline" size="sm" className="rounded-full h-12 w-12 flex items-center justify-center">👍</Button>
                <Button variant="outline" size="sm" className="rounded-full h-12 w-12 flex items-center justify-center">👎</Button>
              </div>
            </div>
            
            <div className="bg-sauna-beige/50 p-5 rounded-lg">
              <h4 className="font-medium mb-3">Open Question</h4>
              <p className="text-sm text-gray-600 mb-4">
                We're just getting started and want to build exactly what you need:
              </p>
              <div className="bg-white p-4 rounded-lg border border-gray-200">
                <p className="font-medium text-sauna-navy mb-2">
                  "What would make SaunaDip worth €20/month for your business?"
                </p>
                <div className="flex flex-col gap-2">
                  <input 
                    type="text" 
                    placeholder="Type your answer here..." 
                    className="border border-gray-200 rounded-md p-2 text-sm"
                  />
                  <Button size="sm" className="self-end bg-sauna-blue hover:bg-sauna-blue/90">
                    Send Feedback
                  </Button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-6 text-sm text-gray-500">
            <p>Our team reads every piece of feedback and uses it to guide our product roadmap.</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default FeedbackCard;
